import React from "react";
import { Function0, Function1 } from "lodash";
import { Modal } from "react-bootstrap";

import { Button, CloseButton } from "components";

import MultilineTitle, { Title } from "../components/multilineTitle";

import styles from "./confirmationModal.module.scss";

export type ConfirmationModalProps = {
	title: Title;
	body?: string;
	show: boolean;
	onHide: Function0<void>;
	onConfirm: Function1<any, Promise<void> | void>;
	onCancel?: Function0<void>;
	buttonCancel?: string;
	buttonOk?: string;
	dialogAs?: any;
	backdrop?: any;
	restoreFocus?: boolean;
	isButtonOkHidden?: boolean;
	titleClassName?: string;
};

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
	title,
	body,
	show,
	onHide,
	onConfirm,
	onCancel,
	buttonCancel = "Cancel",
	buttonOk = "Yes",
	dialogAs,
	backdrop,
	restoreFocus,
	isButtonOkHidden = false,
	titleClassName,
}) => {
	const handleOk = async (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
		try {
			e.persist();
			await onConfirm(e);
		} finally {
			if (!e.isDefaultPrevented()) onHide();
		}
	};

	const handleClose = () => {
		onCancel?.();
		onHide();
	};

	return (
		<Modal
			className={styles.confirmationPopup}
			show={show}
			onHide={onHide}
			animation={false}
			centered
			dialogAs={dialogAs}
			backdrop={backdrop}
			restoreFocus={restoreFocus}
		>
			<Modal.Header className={styles.header}>
				<MultilineTitle
					title={title}
					className={`${styles.title} ${titleClassName}`}
				/>
				<CloseButton onClick={handleClose} />
			</Modal.Header>
			{body !== undefined && (
				<Modal.Body className={styles.body}>{body}</Modal.Body>
			)}
			<Modal.Footer className={styles.footer}>
				<Button
					onClick={handleClose}
					value={buttonCancel}
					variant="outline-primary"
					className="mr-4"
				/>
				{!isButtonOkHidden && (
					<Button onClick={e => handleOk(e)} value={buttonOk} />
				)}
			</Modal.Footer>
		</Modal>
	);
};

export default ConfirmationModal;
